<div class="min-h-screen flex items-center justify-center bg-gradient-to-r from-orange-400 via-red-500 to-pink-500">
  <div class="max-w-md w-full space-y-8 p-10 bg-white bg-opacity-90 shadow-2xl rounded-lg">
    <div class="text-center">
      <img src="../../assets/logoUp.webp" alt="Logo"
        class="mx-auto h-24 w-24 rounded-full border-4 border-white shadow-md">
      <h2 class="mt-6 text-3xl font-extrabold text-gray-900">
        Inicia sesión en tu cuenta
      </h2>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="handleLogin()" class="mt-8 space-y-6">
      <div class="rounded-md shadow-sm space-y-3">
        <div>
          <label for="email-address" class="sr-only">Correo electrónico</label>
          <input formControlName="username" id="email-address" type="email" autocomplete="email" required
            class="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900  focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm"
            placeholder="Correo electrónico">
        </div>
        <div class="relative">
          <label for="password" class="sr-only">Contraseña</label>
          <input formControlName="password" id="password" [type]="showPassword ? 'text' : 'password'"
            autocomplete="current-password" required
            class="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-orange-500 focus:border-orange-500 focus:z-10 sm:text-sm"
            placeholder="Contraseña">
          <i [ngClass]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" (click)="togglePasswordVisibility()"
            class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"></i>
        </div>
      </div>
      <div>
        <button [disabled]="isLoading" type="submit"
          class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500">
          <span *ngIf="!isLoading">Iniciar sesión</span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            Cargando...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>